export default __webpack_public_path__ + "static/media/MACS GMP Product Flyer.d7f29366.pdf";